import { GetAllUsersResponseData, UserCreateUpdateType } from '@/types/user.types';
import { Option } from '@/types/types';
import { axios } from '@/lib/axios';

const PATH = '/api/users';

const createUpdate = async (user: UserCreateUpdateType) => {
  const response = await axios.post(PATH, user);
  return response.data.id;
};

const getAll = async () => {
  const response = await axios.get<GetAllUsersResponseData[]>(PATH);
  return response.data;
};

const getById = async (id: number) => {
  const response = await axios.get(`${PATH}/${id}`);
  return response.data.data;
};

const dropdownOptions = async () => {
  const response = await axios.get<Option[]>(`${PATH}/administration/dropdown`);
  return response.data;
};

const checkUsernameExists = async (username: string, excludeUserId?: number | null) => {
  const response = await axios.get<{ exists: boolean }>(`${PATH}/username-exists`, {
    params: { username, ...(excludeUserId != null && { excludeUserId }) },
  });
  return response.data.exists;
};

const UserService = {
  createUpdate,
  getById,
  getAll,
  dropdownOptions,
  checkUsernameExists,
};

export default UserService;
